<template>
  <section class="container itti">
    <div class="itti__header text-center">
      <h2>
        <span class="fall">ITTI</span><br />
        votre école Taxi et VTC
      </h2>
      <div class="col-lg-6 itti__header-img">
        <div class="cadre">
          <img
            src="@/assets/pictures/itti-front.webp"
            class="img-fluid"
            alt="front-of-the-taxi-institut"
            loading="lazy"
          />
        </div>
      </div>
      <p class="text-center itti__lead">
        Votre partenaire de confiance pour des
        <strong>formations</strong> complètes et professionnelles dans le
        domaine du
        <strong>transport de personnes</strong> (<strong>t3p</strong>).
      </p>
    </div>
    <div class="itti__row">
      <div class="item fall">
        <div class="item__box">
          <div class="item__content">
            <div class="item__head">
              <i class="fa fa-eur" aria-hidden="true"></i>
              <h3>Financements</h3>
            </div>
            <p>
              L'Institut Taxi accepte le
              <strong>Compte Personnel de Formation</strong>
              <strong>(CPF)</strong> pour ses <strong>formations</strong> et
              propose également un paiement en 3 fois sans frais.
            </p>
          </div>
        </div>
      </div>
      <div class="item fall">
        <div class="item__box">
          <div class="item__content item__content--blue">
            <div class="item__head">
              <i class="fa fa-wheelchair" aria-hidden="true"></i>
              <h3>PMR</h3>
            </div>
            <p>
              Nos infrastructures adaptées, garantissent un accès facile et
              confortable à nos locaux de
              <strong>formation aux personnes à mobilité réduite</strong>
              (<strong>PMR</strong>).
            </p>
          </div>
        </div>
      </div>
      <div class="item fall">
        <div class="item__box">
          <div class="item__content">
            <div class="item__head">
              <i class="fa fa-pen-alt"></i>
              <h3>Cours</h3>
            </div>
            <p>
              L'Institut Taxi propose des
              <strong>formations</strong> flexibles adaptées à différents
              horaires, y compris des <strong>cours du soir</strong> et des
              <strong>formations accélérées</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="hr-d itti__divider"></div>
</template>

<script>
export default {
  name: "IttiHome",
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".fall");
    });
  },
};
</script>

<style lang="scss" scoped>
.itti {
  padding: 34px 18px 34px;

  @media screen and (min-width: 768px) {
    padding-inline: 22px;
  }

  @media screen and (min-width: 992px) {
    padding: 46px 0 44px;
  }

  &__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & h2 {
      color: $color-text;
      margin-bottom: 24px;
      line-height: 1.06;

      @media screen and (min-width: 992px) {
        margin-bottom: 28px;
      }

      & span {
        font-family: "cunia", "Arial Black", Arial, sans-serif;
        color: $color-secondary;
        font-size: clamp(3rem, 5vw, 4.4rem);
      }
    }

    & p {
      max-width: 860px;
      margin: 0 auto;
    }
  }

  &__lead {
    font-size: clamp(1.24rem, 1.1rem + 0.34vw, 1.4rem);
    line-height: 1.64;
  }

  &__header-img {
    width: 100%;
    max-width: 640px;
    padding: 24px 0 40px;

    @media screen and (min-width: 992px) {
      padding: 30px 0 46px;
    }

    & .cadre {
      padding: 3px;
      background-color: $color-primary;
      border: 0.3px $color-secondary outset;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 20px;
    }
  }
  &__row {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: min(100%, 1100px);
    margin: 50px auto 0;
    padding-inline: 0;
    align-items: stretch;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 16px 30px rgba(0, 16, 32, 0.1);

    @media screen and (min-width: 768px) {
      width: min(100%, 1120px);
    }

    @media screen and (min-width: 992px) {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      margin-top: 62px;
    }

    & .item {
      margin: 0;
      display: flex;
      min-width: 0;

      &:not(:first-child) .item__content {
        border-top-width: 0;
      }

      @media screen and (min-width: 992px) {
        &:not(:first-child) .item__content {
          border-top-width: 1px;
          border-left-width: 0;
        }
      }

      &__box {
        width: 100%;
        display: flex;
      }

      &__content {
        border: 1px solid rgba(0, 42, 84, 0.12);
        border-radius: 0;
        min-height: 206px;
        padding: 18px 18px 18px;
        background-color: $color-secondary;
        color: $color-text;
        box-shadow: none;
        display: flex;
        flex-direction: column;
        gap: 14px;
        width: 100%;
        height: 100%;
        transition: filter 0.2s ease, background-color 0.2s ease;

        @media screen and (min-width: 992px) {
          min-height: 226px;
          padding: 20px 20px 18px;
          gap: 16px;
        }

        & p {
          color: inherit;
          font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
          font-size: clamp(1rem, 0.96rem + 0.14vw, 1.08rem);
          font-weight: 500;
          margin: 0;
          line-height: 1.5;
          flex: 1 1 auto;
        }

        &--blue {
          border-color: rgba(255, 255, 255, 0.1);
          background-color: $color-primary;
          color: $color-text-light;
          box-shadow: none;

          .item__head h3,
          .item__head i,
          p {
            color: inherit;
          }

          .item__head i {
            color: $color-secondary;
            background: rgba(255, 255, 255, 0.12);
          }
        }

        @media (hover: hover) {
          &:hover {
            filter: brightness(1.02);
          }

          &--blue:hover {
            filter: brightness(1.04);
          }
        }
      }

      &__head {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        margin-bottom: 0;
        min-height: 30px;
        text-align: left;

        h3 {
          color: $color-text-light;
          margin: 0;
          font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
          font-size: clamp(1rem, 0.96rem + 0.12vw, 1.08rem);
          font-weight: 700;
          line-height: 1.12;
          letter-spacing: 0.01em;
        }

        i {
          width: 28px;
          height: 28px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: $color-secondary;
          font-size: 0.94rem;
          flex: 0 0 auto;
          background: $color-primary;
        }
      }
    }
  }

  &__divider {
    margin-top: 28px;
    margin-bottom: 0;
  }
}

.fall.active {
  @include fall-down(1s);
}
</style>
